module.exports = __webpack_public_path__ + "img/page-14.7c0c2b5f.jpg";